import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from 'app/base';
import { Validators, FormGroup } from '@angular/forms';
import { Element } from '@angular/compiler';

@Component({
    selector: 'minhas-permissoes-etapa1',
    templateUrl: './minhas-permissoes-etapa1.component.html',
})
export class CrudMinhasPermissoesEtapa1Component extends BaseStepComponent {
    @Input() SistemaOptions: SelectItem[];
    @Input() PerfilOptions: SelectItem[];
    @Input() LotacaoOptions: SelectItem[];

    @Input() uploadedFiles: any[] = [];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    init() { 
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }
        this.uploadedFilesChange.emit(this.uploadedFiles);
    }

    removeElementList(value: any) {
        this.uploadedFiles.forEach((item, index) => {
            if (item.nome_arquivo === value.file.name && item.id < 1) {
                super.removeFromList(this.uploadedFiles, this.uploadedFilesChange, index, 'anexos');
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/minhas-permissoes/crud/etapas/minhas-permissoes-etapa1.component.ts